import axios from './axios.config';

export const getJobs = () => async(dispatch) => {
    try {
        dispatch({ type: "fetchJobsRequest" });
        const { data } = await axios.get(`/jobs/getjob`);
        dispatch({ type: "fetchJobsSuccess", payload: data });
    } catch (error) {
        dispatch({ type: "fetchJobsFailure", payload: error });
    }
}

export const getPosts = () => async(dispatch) => {
    try {
        dispatch({ type: "fetchPostsRequest" });
        const { data } = await axios.get(`/posts/getPosts`);
        dispatch({ type: "fetchPostsSuccess", payload: data.posts });
    } catch (error) {
        dispatch({ type: "fetchPostsFailure", payload: error });
    }
}

export const getResources = () => async(dispatch) => {
    try {
        dispatch({ type: "fetchResourcesRequest" });
        const { data } = await axios.get(`/resource/getresources`);
        dispatch({ type: "fetchResourcesSuccess", payload: data });
    } catch (error) {
        dispatch({ type: "fetchResourcesFailure", payload: error });
    }
}

export const getMyPosts = (userId) => async(dispatch) => {
    try {
        dispatch({ type: "fetchPostsRequest" });
        const { data } = await axios.get(`/posts/getPosts/my/${userId}`);
        dispatch({ type: "fetchPostsSuccess", payload: data.posts });
    } catch (error) {
        dispatch({ type: "fetchPostsFailure", payload: error });
    }
}

export const getBookMarkedPosts = () => async(dispatch) => {
    try {
        dispatch({ type: "fetchPostsRequest" });
        const { data } = await axios.get(`/posts/getPosts/bookmarked`);
        dispatch({ type: "fetchPostsSuccess", payload: data.posts });
    } catch (error) {
        dispatch({ type: "fetchPostsFailure", payload: error });
    }
}

export const getLikedPosts = (userId) => async(dispatch) => {
    try {
        dispatch({ type: "fetchPostsRequest" });
        const { data } = await axios.get(`/posts/getPosts/Liked/${userId}`);
        dispatch({ type: "fetchPostsSuccess", payload: data.posts });
    } catch (error) {
        dispatch({ type: "fetchPostsFailure", payload: error });
    }
}

export const deletePost = (postId) => async (dispatch) => {
    try {
        dispatch({ type: "deletePostRequest" });
        const { data } = await axios.delete(`/posts/delete/${postId}`);
        dispatch({ type: "deletePostSuccess", payload: data.message });
        dispatch(getPosts()); 
    } catch (error) {
        dispatch({
            type: "deletePostFailure",
            payload: error.response?.data?.message || error.message,
        });
    }
}